import { ref } from 'vue'
import { getHeadersWithToken, handleResponse } from '@/utils/http'

export const api = {
  fetchDeliveriesAbortController: ref(new AbortController()),

  cancelFetchDeliveries: () => {
    api.fetchDeliveriesAbortController.value.abort()
  },

  fetchDeliveries: async ({ locationId }) => {
    const endpoint = route('api.tables.deliveries')

    api.fetchDeliveriesAbortController.value = new AbortController()

    const resp = await fetch(endpoint, {
      signal: api.fetchDeliveriesAbortController.value.signal,
      method: 'POST',
      headers: getHeadersWithToken(),
      body: JSON.stringify({
        filterModel: {
          fulfillment_location_id: {
            filterType: 'text',
            type: 'equals',
            filter: locationId
          }
        }
      })
    })

    return handleResponse('fetch', resp)
  },

  assignVehicleDriver: async (deliveryIds, vehicleId, driverOneId, driverTwoId) => {
    const endpoint = route('api.deliveries.assign')

    const resp = await fetch(endpoint, {
      method: 'POST',
      headers: getHeadersWithToken(),
      body: JSON.stringify({
        deliveries: deliveryIds,
        ...(vehicleId && { vehicle_id: vehicleId }),
        ...(driverOneId && { driver_one_id: driverOneId }),
        ...(driverTwoId && { driver_two_id: driverTwoId })
      })
    })

    return handleResponse('assign', resp)
  },

  mergeDeliveries: async (deliveryIds) => {
    const endpoint = route('api.deliveries.merge')

    const resp = await fetch(endpoint, {
      method: 'POST',
      headers: getHeadersWithToken(),
      body: JSON.stringify({ deliveries: deliveryIds })
    })

    return handleResponse('merge', resp)
  },

  dispatchDeliveries: async (deliveryIds) => {
    const endpoint = route('api.deliveries.dispatch')

    const resp = await fetch(endpoint, {
      method: 'POST',
      headers: getHeadersWithToken(),
      body: JSON.stringify({ deliveries: deliveryIds })
    })

    return handleResponse('dispatch', resp)
  },

  cancelDeliveries: async (orderIds) => {
    const endpoint = route('api.orders.cancel')

    const resp = await fetch(endpoint, {
      method: 'PUT',
      headers: getHeadersWithToken(),
      body: JSON.stringify({ orders: orderIds })
    })

    return handleResponse('cancel', resp)
  },

  notifyOrders: async (deliveryIds) => {
    const endpoint = route('api.deliveries.notify')

    const resp = await fetch(endpoint, {
      method: 'POST',
      headers: getHeadersWithToken(),
      body: JSON.stringify({ deliveries: deliveryIds })
    })

    return handleResponse('notify', resp)
  },

  completeOrders: async (deliveryIds) => {
    const endpoint = route('api.deliveries.bulk_complete')

    const resp = await fetch(endpoint, {
      method: 'POST',
      headers: getHeadersWithToken(),
      body: JSON.stringify({ deliveries: deliveryIds })
    })

    return handleResponse('complete', resp)
  }
}
